/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {HarlequinServerDataParser} from "../HarlequinServerDataParser";
import {IHarlequinGameData, IHarlequinInitData} from "./IHarlequinServerData";
import {
    FeatureBuyTimesBetValue
} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";
export class HarlequinParsedInitData extends ParsedInitData {

    private readonly _doReelNudge:boolean[];
    private readonly _extraSymbolsOnTop:string[][];

    private readonly _wildOverlayReels:boolean [];
    private readonly _wildOverlayReelsBefore:boolean [];

    private readonly _wildMultipliers:number [];
    private readonly _wildMultipliersBefore: number [];

    private readonly _scattersFSCollectedAfter: number [];
    private readonly _scattersFSCollectedBefore: number;

    private readonly _scattersCollectedFSAfter:number;
    private readonly _scattersCollectedFSBefore:number;

    private readonly _scattersCollected:number;
    private readonly _scatterCollected:number;
    private readonly _extraScatterThisFSSpin: number [];

    private readonly _wildDrop:boolean [];

    private readonly _betLineWins:any [];

    private readonly _totalRespinWin:number;

    public get totalRespinWin():number {
        return this._totalRespinWin;
    }

    public get betLineWins():any [] {
        return this._betLineWins;
    }

    public get wildDrop():boolean [] {
        return this._wildDrop;
    }

    public get scattersCollected():number {
        return this._scattersCollected;
    }

    public get scatterCollected():number {
        return this._scatterCollected;
    }

    public get scattersFSCollectedAfter():number [] {
        return this._scattersFSCollectedAfter;
    }

    public get scattersFSCollectedBefore():number {
        return this._scattersFSCollectedBefore;
    }

    public get scattersCollectedFSAfter():number {
        return this._scattersCollectedFSAfter;
    }

    public get scattersCollectedFSBefore():number {
        return this._scattersCollectedFSBefore;
    }

    public get doReelNudge():boolean[] {
        return this._doReelNudge;
    }

    public get extraSymbolsOnTop():string[][] {
        return this._extraSymbolsOnTop;
    }

    public get wildOverlayReels():boolean [] {
        return this._wildOverlayReels;
    }

    public get wildOverlayReelsBefore():boolean [] {
        return this._wildOverlayReelsBefore;
    }

    public get wildMultipliers():number [] {
        return this._wildMultipliers;
    }

    public get wildMultipliersBefore():number [] {
        return this._wildMultipliersBefore;
    }

    public get extraScatterThisFSSpin():number [] {
        return this._extraScatterThisFSSpin;
    }

    private readonly _accumulatedRoundWin:string;
    public get accumulatedRoundWin():string {
        return this._accumulatedRoundWin;
    }

    private readonly _featureBuyTimesBetValue:FeatureBuyTimesBetValue[];
    public get featureBuyTimesBetValue():FeatureBuyTimesBetValue[] {
        return this._featureBuyTimesBetValue;
    }

    constructor(rawData:IHarlequinInitData, dataParser:HarlequinServerDataParser) {
        super(rawData, dataParser);

        // TODO: Fix extension typing HELL!
        //this._doReelNudge = dataParser.parseDoReelNudge(rawData);

        // TODO: Fix extension typing HELL!
        //this._extraSymbolsOnTop = dataParser.parseExtraSymbolsOnTopInit(rawData);

        this._wildOverlayReels = rawData.wildOverlayReels;
        this._wildOverlayReelsBefore = rawData.wildOverlaysBefore;

        this._wildMultipliers = rawData.wildMultipliers;
        this._wildMultipliersBefore = rawData.wildMultipliersBefore;

        this._scattersFSCollectedAfter = rawData.scattersFSCollectedAfter;
        this._scattersFSCollectedBefore = rawData.scattersFSCollectedBefore;

        this._scattersCollectedFSAfter = rawData.scattersCollectedFSAfter;
        this._scattersCollectedFSBefore = rawData.scattersCollectedFSBefore;

        this._wildDrop = rawData.wildDrop;
        this._scattersCollected = rawData.scattersCollected;

        this._scatterCollected = rawData.scatterCollected;

        this._extraScatterThisFSSpin = rawData.extraScatterThisFSSpin;
        this._betLineWins = rawData.betLineWins;

        this._totalRespinWin = rawData.totalRespinWin;

        this._featureBuyTimesBetValue = rawData.featureBuyTimesBetValue;
        this._accumulatedRoundWin = rawData.accumulatedRoundWin;
    }
}